module.exports = __webpack_public_path__ + "static/p02_cencerro-3c87fa141f7fa0a7050392243d60d856.png";